import styled from '../../styles/theme';
import PriceSuffixTemplate from './PriceSuffixTemplate';

export const PriceSuffixStyled = styled(PriceSuffixTemplate)`
    background: none;
`;
